import React from 'react';

import { Layout, Tag } from '../element';
import {
  Info,
  InfoContainer,
  InfoDescription,
  InfoStatus,
  TimeLine,
  TimeLineDate,
  TimeLineIconContainer,
  TimeLineItem,
} from './styled';

import { TrackingInfo } from '../../client/services/types';
import { getCountryFlag } from '../../config/countries';

export interface TrackingTimeLineProps {
  list: TrackingInfo[];
}

const TimeLineIcon: React.FC<Pick<TrackingInfo, 'label'>> = ({ label }) => {
  const icon = {
    in_progress: '',
    error: 'el-icon-loading',
    delivered: 'el-icon-check',

    out_off_delivery: 'el-icon-box',
  }[label];

  return (
    <TimeLineIconContainer className={label}>
      <i className={icon} />
    </TimeLineIconContainer>
  );
};

export const TrackingTimeLine: React.FC<TrackingTimeLineProps> = ({ list }) => (
  <Layout.Row gutter={20}>
    <Layout.Col span={24}>
      <TimeLine>
        {list.map((tracking, idx) => (
          <TimeLineItem key={tracking.status + idx.toString()}>
            <TimeLineDate>
              <b>{tracking.displayed_date}</b>
              <span>{tracking.displayed_time}</span>
            </TimeLineDate>
            <TimeLineIcon label={tracking.label} />
            <InfoContainer>
              <Info>
                <div>
                  <img src={getCountryFlag(tracking.current_country)} alt={tracking.current_country} />
                </div>
                <div>
                  <InfoStatus>{tracking.status}</InfoStatus>
                  <Tag className="el-tag--mini el-tag--light">{tracking.status_originator}</Tag>
                </div>
              </Info>
              <InfoDescription>
                {tracking.current_post_code && tracking.current_city && (
                  <>
                    <span className="mr-5">{tracking.current_post_code},</span>
                    <span className="mr-5">{tracking.current_city},</span>
                  </>
                )}
                {tracking.description}
              </InfoDescription>
            </InfoContainer>
          </TimeLineItem>
        ))}
      </TimeLine>
    </Layout.Col>
  </Layout.Row>
);
